export const MAX_NODE_TRANSITIONS = 15;

export const RVFlowBlockVariants = {
    node: "node",
    block: "block",
} as const;

export const RVFlowBlockTypes = {
    AiStart: "AiStart",
    AiPrompt: "AiPrompt",
    AiAction: "AiAction",
    AiLogic: "AiLogic",
    Trigger: "Trigger",
    Agent: "Agent",
    Automated: "Automated",
    Integration: "Integration",
    OtherAction: "OtherAction",
    Timing: "Timing",
    Logic: "Logic",
    AI: "AI",
} as const;

export type DynamicHandle = {
    id?: string | number;
    displayValue?: string | number;
    connectorShouldDisplay: boolean;
    name?: string;
};
